import ElectricianBanner from './ElectricianBanner';

export default ElectricianBanner;
